import {
  Assignment,
  CheckCircleOutline,
  PendingActions,
  AttachMoneyOutlined,
} from '@mui/icons-material';
import { MetricCard } from 'finara-components';

import { useCredits } from '@/hooks/queries/useCredits';

interface AdvanceDashboardProps {
  organizationId?: string;
}

export const AdvanceDashboard: React.FC<AdvanceDashboardProps> = ({ organizationId }) => {
  // Fetch all credits for dashboard metrics
  const { data: creditsData, isLoading } = useCredits({
    limit: 1000,
    ...(organizationId && { organization_id: organizationId }),
  });

  // Calculate metrics from the data
  const totalSolicitudes = creditsData?.data.length ?? 0;
  const pendingRequests =
    creditsData?.data.filter(credit => credit.status === 'pending').length ?? 0;
  const approvedToday =
    creditsData?.data.filter(credit => {
      if (!credit.approved_at) return false;
      const today = new Date().toDateString();
      const approvedDate = new Date(credit.approved_at).toDateString();
      return today === approvedDate;
    }).length ?? 0;

  const totalAmount =
    creditsData?.data
      .filter(credit => credit.status === 'active')
      .reduce((sum, credit) => sum + credit.amount, 0) ?? 0;

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="bg-white/10 animate-pulse rounded-lg h-32" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      <MetricCard
        title="Total Solicitudes"
        value={totalSolicitudes.toString()}
        icon={<Assignment />}
        variant="green"
      />

      <MetricCard
        title="Pendientes Revisión"
        value={pendingRequests.toString()}
        description="Requieren revisión"
        icon={<PendingActions />}
        variant="yellow"
      />

      <MetricCard
        title="Aprobadas Hoy"
        value={approvedToday.toString()}
        icon={<CheckCircleOutline />}
        variant="green"
      />

      <MetricCard
        title="Monto Total"
        value={formatCurrency(totalAmount)}
        icon={<AttachMoneyOutlined />}
        variant="green"
      />
    </div>
  );
};
